import Toast from 'react-native-root-toast';
import { colors } from './constants';
import Firebase from '../components/FirebaseContext';
import { User } from './types/Users';

export function SuccessToast(msg: string): void {
	Toast.show(msg, {
		duration: 5000,
		position: 72,
		shadow: true,
		backgroundColor: colors.lightGreen,
	});
}

export function FailureToast(msg: string): void {
	Toast.show(msg, {
		duration: 5000,
		position: 72,
		shadow: true,
		backgroundColor: colors.red,
	});
}

export async function GetUserByID(id: string): Promise<User | null> {
	const q = await Firebase.firestore().collection('users').where('id', '==', id).get();
	if (!q.empty) {
		return q.docs[0].data() as User;
	}
	return null;
}

export function greet(): string {
	const date = new Date().getHours();
	if (date >= 0 && date < 12) {
		return 'Good morning';
	}
	if (date >= 12 && date < 16) {
		return 'Good afternoon';
	}
	return 'Good evening';
}
